import { PixiToReactEventPropNames } from './EventPropNames';

export const PixiReactIgnoredProps = Object.freeze([
    ...Object.keys(PixiToReactEventPropNames),
    'draw',
]);
